import { curry, is, includes } from 'ramda';

const OR = ' OR ';
const AND = ' AND ';

const op =
  (operator: string) =>
  (values: string[]): string =>
    values.map((str) => `(${str})`).join(operator);

export const and = op(AND);
export const or = op(OR);
export const not = (param: string) => `NOT ${param}`;

const escaped = (value: any) => {
  if (is(String, value) && includes(' ', value)) {
    return `"${value}"`;
  }

  return value;
};

export const attr = curry(
  (name: string, value: any): string => `${name}:${escaped(value)}`
);

export const attributeIn =
  (name: string) =>
  (values: string[]): string => {
    return or(values.map(attr(name)));
  };

export const attributeNotIn =
  (name: string) =>
  (values: string[]): string => {
    return and(values.map((value) => not(attr(name, value))));
  };

export const period = curry(
  (name: string, from: number, to: number): string | void =>
    from && to && `${name}:${from} TO ${to}`
);
